<template>
  <div class="expanded-content">
    <div v-if="props.html" v-katex:auto="{options: katexOptions}">
      <div v-html="props.html"></div>
    </div>
    <slot v-else></slot>
  </div>
</template>

<script setup lang="ts">
  interface Props {
    html?: string;
  }

  const props = withDefaults(defineProps<Props>(), {
    html: undefined,
  });


  const katexOptions = {
    ignoredClasses: [],
    preProcess: (math: Text) => {
      const parentElement = math.parentElement;
      if (parentElement && parentElement.tagName === 'SPAN' && parentElement.classList.contains('katex')) {
        return math.textContent;
      }

      return "";
    }
  };
</script>

<style lang="scss" scoped>
  .expanded-content {
    font-size: 14px;
    line-height: 1.8;
  }
</style>
